// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .update-deal-margin {padding:2px; border: 0;} */
.edit-margin-input { width: 50px; padding: 4px; height: 20px; font-size: 12px;}
.edit-margin-input:focus { outline: none;}


.view-details {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.detail-label {
  font-weight: 600;
  color: #555;
  width: 25%;
}

.detail-value {
  width: 75%;
  color: #222;
  word-break: break-word;
}

/* Status badge */
.detail-badge {
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 600;
}

/* Status colors */
.status-pending {
  background: #fff3cd;
  color: #856404;
}

.status-in-process {
  background: #e7f3ff;
  color: #0d6efd;
}

.status-rejected {
  background: #f8d7da;
  color: #842029;
}

.status-completed {
  background: #d1e7dd;
  color: #0f5132;
}







`, "",{"version":3,"sources":["webpack://./src/components/pages/tools/segment-request/segment-request.css"],"names":[],"mappings":"AAAA,kDAAkD;AAClD,qBAAqB,WAAW,EAAE,YAAY,EAAE,YAAY,EAAE,eAAe,CAAC;AAC9E,2BAA2B,aAAa,CAAC;;;AAGzC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;EACX,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":["/* .update-deal-margin {padding:2px; border: 0;} */\n.edit-margin-input { width: 50px; padding: 4px; height: 20px; font-size: 12px;}\n.edit-margin-input:focus { outline: none;}\n\n\n.view-details {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.detail-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.detail-label {\n  font-weight: 600;\n  color: #555;\n  width: 25%;\n}\n\n.detail-value {\n  width: 75%;\n  color: #222;\n  word-break: break-word;\n}\n\n/* Status badge */\n.detail-badge {\n  padding: 4px 10px;\n  border-radius: 12px;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n/* Status colors */\n.status-pending {\n  background: #fff3cd;\n  color: #856404;\n}\n\n.status-in-process {\n  background: #e7f3ff;\n  color: #0d6efd;\n}\n\n.status-rejected {\n  background: #f8d7da;\n  color: #842029;\n}\n\n.status-completed {\n  background: #d1e7dd;\n  color: #0f5132;\n}\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
